// =========================================================================================@@
// Last Updated Date: May 25, 2025
// Last Updated By: Steven Yuen
// Status Level: 2
// ===========================================================================================

import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useOrganization, useUserList } from 'src/core/graphql/hooks'
import UserListItemDetailsCard from 'src/sites/kits/People/components/UserListItemDetailsCard'
import { Title } from 'src/sites/kits/UI2'

const PeopleAsideBlock = ({ badgeId }) => {
   const targetType = 'organization'
   const targetId = 'current'

   const { organization } = useOrganization()
   const showMembers = organization.memberListEnabled

   const userFilter = {
      limit: 5,
      userRelationshipFilter: {
         entityType: targetType,
         entityId: targetId
      },
      withRelationship: false,
      withRelationshipEntityType: targetType,
      withRelationshipEntityId: targetId
   }

   if (badgeId) {
      userFilter.userRelationshipFilter.hasBadgeId = badgeId
   } else {
      userFilter.userRelationshipFilter.hasRoleParticipantElement = {
         roleType: showMembers ? 'primary' : 'admin',
         status: 'active'
      }
   }

   const { userList } = useUserList(userFilter)

   if (userList.items.length === 0) {
      return null
   }

   return (
      <>
         {!badgeId && (
            <>
               <Title size="xs">{`Community ${showMembers ? 'Members' : 'Admins'} `}</Title>
               <div className="text-sm text-neutral-500 pb-4 pt-2">
                  {showMembers ? 'Connect with these members' : 'Reach out to these admins'}
                  {` of the ${organization.name} Community.`}
               </div>
            </>
         )}
         <div className="mb-5 border-t border-solid line-color">
            {userList.items.map(user => (
               <UserListItemDetailsCard
                  key={user.id}
                  id={user.id}
                  avatarMedia={user.avatarMedia}
                  avatarSize="30px"
                  badges={user.badges}
                  fullName={user.fullName}
                  organization={user.organization}
                  position={user.position}
                  paddingVertical="12px"
               />
            ))}
         </div>
         {showMembers && (
            <div className="w-full text-sm">
               <Link to="/-/people" style={{ color: '#777' }}>
                  <u>See more</u>
               </Link>
            </div>
         )}
      </>
   )
}

PeopleAsideBlock.propTypes = {
   badgeId: PropTypes.string
}

PeopleAsideBlock.defaultProps = {
   badgeId: undefined
}

export default PeopleAsideBlock
